import React from "react";
import "./OrdersChart.css";

import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const OrdersChart = ({ revenue }) => {
  const chartData = months.map((month, index) => {
    const found = revenue.find(
      (item) => item._id.month === index + 1
    );

    return {
      month,
      orders: found ? found.orders : 0,
    };
  });

  const totalOrders = chartData.reduce(
    (sum, item) => sum + item.orders,
    0
  );

  return (
    <div className="orders-chart">

      <div className="orders-header">

        <div>
          <h2>Orders Overview</h2>
          <p>Monthly completed orders</p>
        </div>

        <div className="orders-total">
          {totalOrders}
        </div>

      </div>

      <ResponsiveContainer
        width="100%"
        height={350}
      >
        <LineChart data={chartData}>

          <CartesianGrid strokeDasharray="3 3" />

          <XAxis dataKey="month" />

          <YAxis />

          <Tooltip />

          <Legend />

          <Line
            type="monotone"
            dataKey="orders"
            name="Orders"
            strokeWidth={3}
            dot={{ r: 5 }}
            activeDot={{ r: 8 }}
          />

        </LineChart>
      </ResponsiveContainer>

    </div>
  );
};

export default OrdersChart;